// The English prompt fragments injected by renderPersona() — verbatim from spec
// §4.3. Typed as exhaustive Records so a missing vocabulary term/axis is a
// compile error. The persona vocabulary is deliberately disjoint from the R3.1
// sonic-trait snippets so the two layers never duplicate a keyword (spec §5.3).
export const PERSONA_INFLUENCE_SNIPPETS = {
    the_beatles: "in the spirit of classic Beatles songcraft",
    led_zeppelin: "with Led Zeppelin-style heavy blues-rock dynamics",
    miles_davis: "with Miles Davis-style modal jazz phrasing",
    daft_punk: "with Daft Punk-style filtered house grooves",
    nina_simone: "with Nina Simone-style soulful vocal phrasing",
    radiohead: "with Radiohead-style brooding art-rock textures",
    james_brown: "with James Brown-style tight funk syncopation",
    johnny_cash: "with Johnny Cash-style stark country gravitas",
    bjork: "with Björk-style adventurous art-pop arrangements",
    kraftwerk: "with Kraftwerk-style minimal electronic precision",
    bob_marley: "with Bob Marley-style warm reggae groove",
    aphex_twin: "with Aphex Twin-style intricate electronic detail",
};
// `temperament` — snippet chosen by the 1..5 scalar value. `3` is the neutral
// point and injects nothing (mirrors `energy` in R3.1).
export const PERSONA_TEMPERAMENT_SNIPPETS = {
    discipline: {
        1: "loose and improvised performance",
        2: "relaxed, lightly rehearsed feel",
        3: "",
        4: "tight, well-rehearsed performance",
        5: "precise, meticulously rehearsed performance",
    },
    boldness: {
        1: "restrained and understated delivery",
        2: "modest, reserved delivery",
        3: "",
        4: "bold, confident delivery",
        5: "daring, larger-than-life delivery",
    },
    experimental: {
        1: "conventional, straightforward approach",
        2: "mostly conventional approach",
        3: "",
        4: "exploratory, experimental approach",
        5: "avant-garde, boundary-pushing approach",
    },
};
//# sourceMappingURL=snippets.js.map